import { OnInit } from '@angular/core';

export class WebPage implements OnInit {
    public HasUnsavedChanges: boolean = false;
    // public HasChanges: boolean = false;
    // public Loading: boolean = true;
    // public Processing: boolean = false;
    // public env: IEnvironment = environment;
    // public globals: IGlobals = Globals;
    // public userAccess: UserAccess = Globals.UAC;

    constructor() {
        // if (elementRef) {
        //     elementRef.nativeElement.addEventListener('dragover', (event: DragEvent) => {
        //         const dt = event.dataTransfer;

        //         dt.effectAllowed = 'none';
        //         dt.dropEffect = 'none';

        //         event.stopPropagation();
        //         event.preventDefault();
        //     });
        // }
    }

    public ngOnInit() {
        this.init();
    }

    public init() {
        this.HasUnsavedChanges = false;
        // this.Loading = true;
    }
}
